import { render } from "./checkDescrip1226.vue?vue&type=template&id=713aba72&scoped=true&ts=true"
import script from "./checkDescrip1226.vue?vue&type=script&lang=ts"
export * from "./checkDescrip1226.vue?vue&type=script&lang=ts"

import "./checkDescrip1226.vue?vue&type=style&index=0&id=713aba72&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713aba72"]])

export default __exports__